import {ViewType} from "../../../gd/const/views/view-type"
import AddViewPreviewDefaultForm from "../../../../layout/top/header/portfolio/submenu/add-view/popover/preview/forms/default-form"
import {
    AddView_Group, AddView_GroupEvents,
    AddView_GroupProject,
    AddView_GroupTasks,
    AddView_GroupType
} from "../../../gd-ui/add-view/@types"
import {PORTFOLIO_SUMMARY_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-summary"
import {PORTFOLIO_LIST_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-list"
import {PORTFOLIO_TABLE_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-table"
import {PORTFOLIO_BOARD_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-board"
import {PORTFOLIO_CALENDAR_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-calendar"
import {PORTFOLIO_GANTT_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-gantt"
import {Feature} from "../../../gd/access-control/feature-access/const"
import {PORTFOLIO_WORKLOAD_CONFIG} from "../../../gd/const/views/configs/portfolio/portfolio-workload"
import {PROJECT_TIMELINE_CONFIG} from "../../../gd/const/views/configs/project-timeline";
import {QuickAddItemType} from "../../../../app/quick-add/@types";
import {PROJECT_CALENDAR_CONFIG} from "../../../views/calendar/@config";
import {CUSTOM_VIEW_EVENTS_SUMMARY_CONFIG} from "../../../views/events-summary/@config";

// const debug = "getNewPortfolioViewItemsGrouped"
const debug = false

export default function getNewPortfolioViewItemsGrouped() {

    const res: AddView_Group[] = []

    // Projects
    res.push({
        ...AddView_GroupProject,
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_SUMMARY,
                iconSvg         : PORTFOLIO_SUMMARY_CONFIG.iconSvg,
                title           : PORTFOLIO_SUMMARY_CONFIG.name,
                description     : PORTFOLIO_SUMMARY_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
        ]
    })

    // TASKS
    res.push({
        ...AddView_GroupTasks,
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_LIST,
                iconSvg         : PORTFOLIO_LIST_CONFIG.iconSvg,
                title           : PORTFOLIO_LIST_CONFIG.menuName,
                description     : PORTFOLIO_LIST_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_TABLE,
                iconSvg         : PORTFOLIO_TABLE_CONFIG.iconSvg,
                title           : PORTFOLIO_TABLE_CONFIG.menuName,
                description     : PORTFOLIO_TABLE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_BOARD,
                iconSvg         : PORTFOLIO_BOARD_CONFIG.iconSvg,
                title           : PORTFOLIO_BOARD_CONFIG.menuName,
                description     : PORTFOLIO_BOARD_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            }
        ]
    })

    // EVENTS
    res.push({
        ...AddView_GroupEvents,
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_CALENDAR,
                iconSvg         : PORTFOLIO_CALENDAR_CONFIG.iconSvg,
                title           : PORTFOLIO_CALENDAR_CONFIG.name,
                description     : PORTFOLIO_CALENDAR_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },

        ],
    })

    // PLANNING
    res.push({
        type        : AddView_GroupType.GROUP,
        id          : 'planning',
        icon        : 'i5-gantchart2',
        title       : 'Planning',
        items       : [
            {
                typeId          : ViewType.PORTFOLIO_GANTT,
                iconSvg         : PORTFOLIO_GANTT_CONFIG.iconSvg,
                title           : PORTFOLIO_GANTT_CONFIG.name,
                description     : PORTFOLIO_GANTT_CONFIG.description,
                isPro           : !gd.company.license.portfolioView(ViewType.PORTFOLIO_GANTT),
                proFeature      : Feature.GANTT,
                formComponent   : AddViewPreviewDefaultForm
            },
            {
                typeId          : ViewType.PORTFOLIO_WORKLOAD,
                iconSvg         : PORTFOLIO_WORKLOAD_CONFIG.iconSvg,
                title           : PORTFOLIO_WORKLOAD_CONFIG.name,
                description     : PORTFOLIO_WORKLOAD_CONFIG.description,
                isPro           : !gd.company.license.portfolioView(ViewType.PORTFOLIO_WORKLOAD),
                proFeature      : Feature.WORKLOAD,
                formComponent   : AddViewPreviewDefaultForm
            },
            /*{
                typeId          : ViewType.PROJECT_TIMELINE,
                iconSvg         : PROJECT_TIMELINE_CONFIG.iconSvg,
                title           : PROJECT_TIMELINE_CONFIG.name,
                description     : PROJECT_TIMELINE_CONFIG.description,
                formComponent   : AddViewPreviewDefaultForm
            },*/
        ]
    })

    return res
}
